// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-Dialog-module--cls1--V7Oaw","cls2":"Lightbox-Dialog-module--cls2--3BAz8 Lightbox-Dialog-module--cls1--V7Oaw"};